import { DesignRequest } from "providers/Types";

const isDesignRequestComplete = (
  designRequest: DesignRequest | null | undefined
): boolean =>
  Boolean(
    designRequest &&
      (["Design", "Redesign"] as Array<DesignRequest["queue"]>).includes(
        designRequest.queue
      ) &&
      designRequest.status === "Complete"
  );

/**
 * Sunrun-managed flows use design request status; partner flows fall back to
 * siteModelHasRoofPlanes when a design request is not required.
 */
const isSiteModelComplete = (
  isDesignRequestRequired: boolean,
  designRequest: DesignRequest | null | undefined,
  siteModelHasRoofPlanes: boolean
): boolean => {
  if (isDesignRequestRequired) {
    return isDesignRequestComplete(designRequest);
  }
  return siteModelHasRoofPlanes;
};

const SITE_MODEL_QUEUES: Array<DesignRequest["queue"]> = ["Design", "Redesign"];

/**
 * Returns the most recent createdDate among completed site model design requests.
 * Used as minimumValidDate when fetching site model images from the Design Image Service.
 */
const getSiteModelMinimumValidDate = (
  designRequests: Array<
    Pick<DesignRequest, "createdDate" | "queue" | "status">
  > = []
): string | undefined => {
  const completedSiteModelDates = designRequests
    .filter(
      (request) =>
        SITE_MODEL_QUEUES.includes(request.queue) &&
        request.status === "Complete"
    )
    .map((request) => request.createdDate)
    .filter(Boolean);

  if (completedSiteModelDates.length === 0) {
    return undefined;
  }

  return completedSiteModelDates.reduce((latest, createdDate) =>
    createdDate > latest ? createdDate : latest
  );
};

export {
  isDesignRequestComplete,
  isSiteModelComplete,
  getSiteModelMinimumValidDate,
};
